// extracted by mini-css-extract-plugin
export default {"confirmModal":"ny3ZxL6gz9_SgjGD8pbf","confirmModalStacked":"CpftufRko0bes0InCalL"};